import { render } from "./WidgetRefreshError.vue?vue&type=template&id=1c23006f"
import script from "./WidgetRefreshError.vue?vue&type=script&lang=js"
export * from "./WidgetRefreshError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__